import styled from "styled-components";

export const SDivider = styled.div<{ dividerHeight?: string; dividerWidth?: string }>`
  width: ${({ dividerWidth }) => (dividerWidth ? dividerWidth : "1px")};
  height: ${({ dividerHeight }) => (dividerHeight ? dividerHeight : "1px")};
  background: var(--ui-03);
`;
